module.exports = __webpack_public_path__ + "img/BRCA4_TMKI67.9f1903ba.png";